import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	fetchCreditDebitThunk,
	fetchfundsReceivedHistoryThunk,
	fetchfundsTransferHistoryThunk,
	fetchfundTransferThunk,
	fetchMyWalletThunk,
} from './myWalletApis'

const initialState = {
	myWalletDetailsData: null,
	creditDebitData: [],
	totalCountCreditDebit: 0,
	fundsReceivedHistoryData: [],
	totalCountFundsReceived: 0,
	fundsTransferHistoryData: [],
	totalCountFundsTransfers: 0,
	fundsTransferData: [],
}

export const getMyWalletDetailsData = createAsyncThunk('user/getMyWalletDetailsData', fetchMyWalletThunk)
export const getCreditDebitData = createAsyncThunk('user/getCreditDebitData', fetchCreditDebitThunk)
export const getFundsReceivedHistoryData = createAsyncThunk('user/getFundsReceivedHistoryData', fetchfundsReceivedHistoryThunk)
export const getFundsTransferHistoryData = createAsyncThunk('user/getFundsTransferHistoryData', fetchfundsTransferHistoryThunk)
export const getFundsTransferData = createAsyncThunk('user/getFundsTransferData', fetchfundTransferThunk)

export const myWalletSlice = createSlice({
	name: 'myWallet',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getMyWalletDetailsData.fulfilled, (state, action) => {
			// Directly assign the API response if there's no `data` key
			state.myWalletDetailsData = action.payload
		})
		builder.addCase(getCreditDebitData.fulfilled, (state, action) => {
			state.creditDebitData = action.payload?.data
			state.totalCountCreditDebit = action.payload?.total
		})
		builder.addCase(getFundsReceivedHistoryData.fulfilled, (state, action) => {
			state.fundsReceivedHistoryData = action.payload?.data
			state.totalCountFundsReceived = action.payload?.total
		})
		builder.addCase(getFundsTransferHistoryData.fulfilled, (state, action) => {
			state.fundsTransferHistoryData = action.payload?.data
			state.totalCountFundsTransfers = action.payload?.total
		})
		builder.addCase(getFundsTransferData.fulfilled, (state, action) => {
			state.fundsTransferData = action.payload?.data
		})
	},
})
export default myWalletSlice.reducer
